export const articles = [
  {
    id: 'a1',
    slug: 'rainy-day-umbrella',
    title: '下雨天他把伞往她那边偏了 45 度，被路人拍了下来',
    excerpt: '一场没有预告的秋雨，一把明显倾斜的伞。有人数了数角度，说这是今年最不刻意的一次偏爱。',
    category: 'heartbeat',
    tags: ['心动瞬间', '雨天小事', '路人视角'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20rainy%20street%20scene%20with%20two%20people%20sharing%20one%20umbrella%2C%20umbrella%20tilted%20toward%20one%20side%2C%20warm%20street%20lamp%20glow%20on%20wet%20pavement%2C%20coral%20and%20amber%20color%20palette%2C%20cinematic%20soft%20focus&width=1200&height=800&seq=txart-rain-01&orientation=landscape',
    author: '糖心编辑组',
    date: '2026-09-08',
    readTime: '4 分钟',
    heat: 9821,
    featured: true,
    quote: '真正的偏心不用说出来，伞会替你说话。',
    content: [
      {
        heading: '一把歪掉的伞，藏不住的小心思',
        paragraphs: [
          '视频里其实没什么大场面：湿漉漉的路口，红灯亮了很久，两个人站在同一把伞下。仔细看才会发现，男生的右肩已经湿透，伞面却始终朝着旁边那个人倾斜。',
          '拍照的网友说，自己是在等公交时随手拍的，站了整整一个红灯才发现这个细节。她把照片发出来时只配了一句话：原来喜欢一个人，连下雨的方向都会跟着她走。',
        ],
      },
      {
        heading: '为什么这类画面总让人上头',
        paragraphs: [
          '下雨天是最好用的心动滤镜。雨声会盖掉周围的杂音，视线会自动收窄到眼前这一把伞、这一点距离。',
          '比起轰轰烈烈的告白，这种下意识的照顾更让人相信。因为他没在表演，只是身体先替大脑做了选择。',
        ],
      },
      {
        heading: '把这份默认的温柔记下来',
        paragraphs: [
          '如果你也曾被人这样倾斜过伞，不妨把这个瞬间写进手机备忘录。很多年后回看，你会发现甜味从来没有过期。',
          '关注糖心吃瓜的心动瞬间板块，每天收一点让人嘴角上扬的画面。',
        ],
      },
    ],
  },
  {
    id: 'a2',
    slug: 'official-anniversary',
    title: '他们用同一张照片官宣，配文只差一个字',
    excerpt: '两个人在同一分钟发出同一张合照，文案分别是“是他”“是她”。评论区从第一条开始就彻底失控。',
    category: 'official',
    tags: ['官宣', '情侣小事', '全网同喜'],
    cover: 'https://readdy.ai/api/search-image?query=Celebratory%20announcement%20scene%20with%20pink%20and%20coral%20heart%20balloons%2C%20confetti%2C%20soft%20cream%20background%2C%20warm%20golden%20light%2C%20festive%20editorial%20still%20life&width=1200&height=800&seq=txart-offi-02&orientation=landscape',
    author: '糖心编辑组',
    date: '2026-09-07',
    readTime: '3 分钟',
    heat: 12460,
    featured: true,
    quote: '同一天、同一张照片、同一句话，只是把“他”换成了“她”。',
    content: [
      {
        heading: '官宣的方式，简单到只剩下喜欢',
        paragraphs: [
          '没有长篇小作文，也没有精心剪辑的视频。两个人几乎在同一分钟晒出了同一张背影合照，一个写“是他”，一个写“是她”。',
          '评论区第一句话是：这也太对仗了。后面跟着几万条祝福，整齐得像约好了一样。',
        ],
      },
      {
        heading: '高调还是低调，其实看的是细节',
        paragraphs: [
          '这对情侣在公开之前几乎没有互动痕迹，唯一能对上的是两个人戴了很久的同款耳机。',
          '真正让人相信的官宣，从来不靠排场，而是那些早就存在、只是大家当时没读懂的默契。',
        ],
      },
      {
        heading: '祝福之外，还想说一句',
        paragraphs: [
          '公开是一件需要勇气的事，尤其是把私人生活放到很多人面前。作为吃瓜的人，给足祝福、少一点盘问，就是最好的礼貌。',
        ],
      },
    ],
  },
  {
    id: 'a3',
    slug: 'midnight-noodles',
    title: '加班到深夜，他在楼下拎着一碗还烫的面',
    excerpt: '她随口说过一句“楼下那家风很大”，他就记了整整两周。',
    category: 'love-notes',
    tags: ['恋爱小料', '深夜', '被记住的细节'],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20night%20street%20scene%20with%20a%20bowl%20of%20steaming%20noodles%20in%20takeaway%20cup%2C%20soft%20window%20lights%20in%20background%2C%20cozy%20coral%20and%20amber%20tones%2C%20lifestyle%20editorial%20photography&width=1200&height=800&seq=txart-noodle-03&orientation=landscape',
    author: '匿名投稿',
    date: '2026-09-06',
    readTime: '5 分钟',
    heat: 8730,
    featured: false,
    quote: '被记住的从来不是那碗面，而是她随口说的那句“风很大”。',
    content: [
      {
        heading: '一句随口的抱怨，变成了两周后的惊喜',
        paragraphs: [
          '投稿的女生说，自己加班到十一点半，出楼门看到熟悉的身影蹲在台阶上，怀里抱着一份外卖。',
          '他说：你上周提过楼下那家风大，我就多绕了两百米，从背面那家买的，还热着。',
        ],
      },
      {
        heading: '恋爱小料为什么总是细枝末节最好嗑',
        paragraphs: [
          '因为没有剧本。一个人记不记得你随口说过的话，骗不了人。',
          '很多关系里最动人的部分，不是生日那天的仪式感，而是某个加班夜里的一碗面、一句“楼下等你”。',
        ],
      },
      {
        heading: '把这份心思还回去',
        paragraphs: [
          '糖心吃瓜提醒：被偏爱的时候，也记得给一点回声。一句“我注意到了”，就能让这份温柔继续流动下去。',
        ],
      },
    ],
  },
  {
    id: 'a4',
    slug: 'same-earphones',
    title: '他们被扒出戴了很久的同款耳机，时间线意外地整齐',
    excerpt: '不是同一天买的，却是从相识那周开始，一起戴到了现在。',
    category: 'official',
    tags: ['官宣', '细节控', '时间线'],
    cover: 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20wireless%20earbuds%20resting%20on%20a%20warm%20cream%20knitted%20blanket%2C%20soft%20natural%20light%2C%20coral%20and%20beige%20palette%2C%20minimal%20editorial%20still%20life&width=1200&height=800&seq=txart-earbuds-04&orientation=landscape',
    author: '瓜田侦探',
    date: '2026-09-05',
    readTime: '4 分钟',
    heat: 10240,
    featured: false,
    quote: '线索从来不少，只是我们当时没往那个方向看。',
    content: [
      {
        heading: '把散落的照片拼起来，时间线就出现了',
        paragraphs: [
          '网友整理了两人过去一年的公开活动照，发现从某个秋天开始，两个人的耳机型号就固定了下来。',
          '更巧的是，那个秋天正好是他们第一次同框的时间。',
        ],
      },
      {
        heading: '吃瓜也要有分寸',
        paragraphs: [
          '梳理时间线是吃瓜的乐趣之一，但任何讨论都应停在公开信息的范围内。',
          '糖心吃瓜的原则很简单：只看公开的、温柔的、不伤人的部分。',
        ],
      },
      {
        heading: '这对的故事告诉我们什么',
        paragraphs: [
          '有些心意藏不住，不是因为刻意，而是因为喜欢这件事，本身就很难完全收好。',
        ],
      },
    ],
  },
  {
    id: 'a5',
    slug: 'shared-umbrella-list',
    title: '情侣小事清单：一起做过这 8 件小事，感情通常很稳',
    excerpt: '没有一条和钱有关，却每一条都写着“我们”。',
    category: 'couple-things',
    tags: ['情侣小事', '清单', '相处'],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20flat%20lay%20of%20a%20notebook%20with%20handwritten%20checklist%2C%20two%20coffee%20cups%2C%20small%20potted%20plant%20on%20cream%20desk%2C%20terracotta%20and%20honey%20tones%2C%20lifestyle%20editorial%20photography&width=1200&height=800&seq=txart-list-05&orientation=landscape',
    author: '糖心编辑组',
    date: '2026-09-04',
    readTime: '6 分钟',
    heat: 7620,
    featured: false,
    quote: '恋爱真正的黏合剂，是一起完成的那些无关紧要。',
    content: [
      {
        heading: '八个不花钱的小事',
        paragraphs: [
          '一、一起逛过菜市场并分工买菜。二、为对方挑过一次不好看的睡衣。三、在同一个雨天共撑一把伞。四、一起看过一次日出或者很晚的星星。',
          '五、给对方剪过一次指甲或者吹过一次头发。六、一起收拾过一次房间。七、记得对方不吃什么。八、愿意为对方多走两站路。',
        ],
      },
      {
        heading: '为什么这些小事比大惊喜更管用',
        paragraphs: [
          '大惊喜负责制造记忆点，小事负责维持体感。关系长期稳定，靠的是后者。',
          '当两个人愿意一起处理琐碎，其实是在反复确认：我愿意和你过日子。',
        ],
      },
      {
        heading: '给想认真一点的人',
        paragraphs: [
          '挑一条你今天就能做到的，晚上回去把它做掉。糖心吃瓜的甜味瓜，很多时候就是这么长出来的。',
        ],
      },
    ],
  },
  {
    id: 'a6',
    slug: 'first-meeting-cafe',
    title: '第一次见面她在咖啡杯上画了个笑脸，他一留就是三年',
    excerpt: '那个纸杯现在还在他家书架上，写着当天的日期。',
    category: 'heartbeat',
    tags: ['心动瞬间', '初见', '纪念'],
    cover: 'https://readdy.ai/api/search-image?query=Warm%20coffee%20cup%20with%20a%20hand%20drawn%20smiley%20face%20on%20the%20paper%20sleeve%2C%20soft%20cream%20cafe%20background%2C%20honey%20and%20coral%20light%2C%20cozy%20editorial%20photography&width=1200&height=800&seq=txart-cafe-06&orientation=landscape',
    author: '匿名投稿',
    date: '2026-09-03',
    readTime: '4 分钟',
    heat: 6890,
    featured: false,
    quote: '第一次见面留下的东西，最舍不得扔。',
    content: [
      {
        heading: '一个随手画的笑脸',
        paragraphs: [
          '投稿的男生说，第一次约她喝咖啡，她等饮品的时候在纸杯上画了个歪歪的笑脸，然后推过来。',
          '他把杯子带回了家，晾干后放在书架上。三年过去，杯口有点发黄，他依然没舍得扔。',
        ],
      },
      {
        heading: '心动瞬间其实很轻',
        paragraphs: [
          '轻到只是一个图案、一句玩笑、一次偏头。但正因为轻，才格外真实。',
          '我们在心动瞬间板块收集了许多这样的画面，它们都不吵，却都能被记住很久。',
        ],
      },
      {
        heading: '要不要也留一个',
        paragraphs: [
          '下次约会，试着留一件小东西——票根、便签、一片干花。时间会替它升值。',
        ],
      },
    ],
  },
  {
    id: 'a7',
    slug: 'long-distance-package',
    title: '异地三个月，他寄来的快递箱里装满了日常',
    excerpt: '一支她常用的护手霜、一包老家的红糖、一张手写的作息表。',
    category: 'love-notes',
    tags: ['恋爱小料', '异地', '包裹'],
    cover: 'https://readdy.ai/api/search-image?query=Open%20cardboard%20care%20package%20with%20handwritten%20note%2C%20hand%20cream%20tube%20and%20a%20small%20jar%20of%20brown%20sugar%2C%20warm%20wooden%20table%2C%20coral%20and%20cream%20palette%2C%20editorial%20flat%20lay&width=1200&height=800&seq=txart-package-07&orientation=landscape',
    author: '糖心编辑组',
    date: '2026-09-02',
    readTime: '5 分钟',
    heat: 8140,
    featured: true,
    quote: '异地恋最好的翻译器，是一个装满日常的快递箱。',
    content: [
      {
        heading: '箱子里没有一件贵重物品',
        paragraphs: [
          '开箱的时候她想笑又想哭：护手霜是她上次视频抱怨手干时提到的，红糖是他说“你那几天别喝冰的”寄来的，还有一张手写作息表，写着“到点睡觉”。',
          '最贵的东西是那张纸，因为上面写满了他在意的顺序。',
        ],
      },
      {
        heading: '异地关系里，细节是可以被邮寄的',
        paragraphs: [
          '距离会放大不确定性，所以更需要具体的东西来承接想念。',
          '一个包裹的意义不在于价格，而在于它证明：你在我看不见的地方，也一直被我惦记着。',
        ],
      },
      {
        heading: '给正在异地的你们',
        paragraphs: [
          '如果最近有点累，试着把“我想你”换成一个具体的动作。糖心吃瓜见过太多这样的甜味瓜，它们都很朴素，但都很管用。',
        ],
      },
    ],
  },
  {
    id: 'a8',
    slug: 'wrong-stop',
    title: '她坐过站两站，只因为不想打断他的分享',
    excerpt: '他说起工作里的一件小事，认真得像在讲一个长篇故事。',
    category: 'couple-things',
    tags: ['情侣小事', '通勤', '倾听'],
    cover: 'https://readdy.ai/api/search-image?query=Evening%20bus%20window%20scene%20with%20warm%20city%20lights%20bokeh%20outside%2C%20two%20silhouettes%20chatting%2C%20cozy%20amber%20and%20coral%20tones%2C%20cinematic%20soft%20focus&width=1200&height=800&seq=txart-bus-08&orientation=landscape',
    author: '匿名投稿',
    date: '2026-09-01',
    readTime: '3 分钟',
    heat: 5970,
    featured: false,
    quote: '喜欢一个人，会愿意绕点远路。',
    content: [
      {
        heading: '过站两站，只为了把那句话听完',
        paragraphs: [
          '她说自己其实早就该下车了，但看他讲得那么投入，就没打断。',
          '等到他讲完，车已经过了两站，两个人又多走了十五分钟。她说不亏。',
        ],
      },
      {
        heading: '倾听也是一种表白',
        paragraphs: [
          '在关系里，被认真听完整一段话，是很奢侈的事。',
          '愿意绕路的那一方，其实是在用行动说：你说的这些，对我重要。',
        ],
      },
      {
        heading: '今天试试听完再回答',
        paragraphs: [
          '不急着给建议，不急着转话题，也许你会发现对方脸上的光。',
        ],
      },
    ],
  },
  {
    id: 'a9',
    slug: 'sunrise-heartbeat',
    title: '凌晨四点出发去看日出，结果两个人都睡着了',
    excerpt: '计划很完整，结果只看到了对方睡着的样子。',
    category: 'heartbeat',
    tags: ['心动瞬间', '日出', '失控计划'],
    cover: 'https://readdy.ai/api/search-image?query=Soft%20dawn%20sky%20over%20a%20calm%20hilltop%2C%20warm%20peach%20and%20coral%20gradient%20clouds%2C%20two%20folded%20blankets%20on%20the%20grass%2C%20serene%20cinematic%20landscape&width=1200&height=800&seq=txart-sunrise-09&orientation=landscape',
    author: '糖心编辑组',
    date: '2026-08-31',
    readTime: '4 分钟',
    heat: 6480,
    featured: false,
    quote: '计划失败了，但那天依然是最好的一个早晨。',
    content: [
      {
        heading: '闹钟响了三次，最后还是睡着了',
        paragraphs: [
          '两个人凌晨四点出门，爬到山顶铺好毯子等日出。等太阳真的出来时，他们都在打盹。',
          '醒来后他拍了一张她裹着毯子的照片，配文：日出没看成，但是风景不错。',
        ],
      },
      {
        heading: '不完美的记忆反而更牢固',
        paragraphs: [
          '因为我们记住了情绪，而不是画面。那种“计划外也很好”的松弛感，本身就是关系里的糖。',
        ],
      },
      {
        heading: '下一次还可以再去',
        paragraphs: [
          '糖心吃瓜建议：把没看成的那次日出，留到下一个纪念日。这就是甜味瓜的续集。',
        ],
      },
    ],
  },
  {
    id: 'a10',
    slug: 'anniversary-letter',
    title: '他把三年来的聊天记录挑出 52 条，做成了一本小书',
    excerpt: '每周一句，刚好是一年。装订得不算精致，但每一页都可以读很久。',
    category: 'official',
    tags: ['官宣', '纪念日', '手作'],
    cover: 'https://readdy.ai/api/search-image?query=Handmade%20booklet%20of%20printed%20chat%20screenshots%20on%20a%20cream%20desk%2C%20ribbon%20bookmark%2C%20warm%20coral%20and%20honey%20lighting%2C%20editorial%20flat%20lay%20photography&width=1200&height=800&seq=txart-book-10&orientation=landscape',
    author: '匿名投稿',
    date: '2026-08-30',
    readTime: '5 分钟',
    heat: 9130,
    featured: true,
    quote: '把聊天记录做成书，是把“我们”装订了起来。',
    content: [
      {
        heading: '52 条记录，一年一句',
        paragraphs: [
          '他翻了三年聊天记录，挑了 52 条最能代表那段时间的话，按周排好，打印装订。',
          '第一页写着开始的那句“在吗”，最后一页留着空白，说留给接下来的一年。',
        ],
      },
      {
        heading: '这一类官宣为什么打动人',
        paragraphs: [
          '因为它不炫耀结果，而是展示过程。别人看到的是一本书，当事人看到的是一整段共同生活。',
        ],
      },
      {
        heading: '给小书一个位置',
        paragraphs: [
          '糖心吃瓜觉得，好的纪念品应该被放在看得见的地方。它提醒你，被认真对待过的日子一直都在。',
        ],
      },
    ],
  },
];

export default articles;